import React from "react";
import squareIcon from "../../../src/assets/images/icon-square.png";
import venmoIcon from "../../../src/assets/images/icon-venmo.png";
import PayPalIcon from "../../../src/assets/images/icon-PayPal.png";

interface Props {
  team: any;
  entryFee?: number;
}

export default function PaymentHandlerRenderer({ team, entryFee }: Props) {
  if (!team) return null;

  const { payPal, cashApp, venmo } = team;

  if (!payPal && !cashApp && !venmo) {
    return <></>;
  }

  const handlePayment = (method: string) => () => {
    let paymentLink = "";
    const amount = entryFee ? Math.ceil(entryFee) : "0.00";
    console.log("method", method);
    switch (method) {
      case "venmo":
        paymentLink = `https://venmo.com/${venmo}?txn=pay&amount=${amount}&note=Challenge%20Entry%20Fee`;
        break;
      case "paypal":
        paymentLink = `https://paypal.me/${payPal}/${amount}USD`;
        break;
      case "cashapp":
        paymentLink = `https://cash.app/$${cashApp}/${amount}`;
        break;
      default:
        break;
    }

    window.open(paymentLink, "_blank");
  };

  return (
    <div className="feesPlatform">
      <strong>Payee</strong>
      {venmo && (
        <span aria-label="Venmo" onClick={handlePayment("venmo")}>
          <img src={venmoIcon} alt="" />
        </span>
      )}
      {payPal && (
        <span aria-label="PayPal" onClick={handlePayment("paypal")}>
          <img src={PayPalIcon} alt="" />
        </span>
      )}
      {cashApp && (
        <span aria-label="Cash App" onClick={handlePayment("cashapp")}>
          <img src={squareIcon} alt="" />
        </span>
      )}
    </div>
  );
}
